import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilityService} from "../../core/services/utility.service";

@Component({
  selector: 'app-loading-pagination',
  templateUrl: './loading-pagination.component.html',
  styleUrls: ['./loading-pagination.component.scss']
})
export class LoadingPaginationComponent implements OnInit {
  @Input() isLoading = false;
  @Input() totalRegistros = 10;
  @Input() registros = 10;
  @Input() pagina = 1;
  @Output() pageChangeLoadingEvent = new EventEmitter<number>();


  constructor(public utilityService: UtilityService) { }

  ngOnInit(): void {

  }

  pageChangeLoadingPagination(event: any){
    this.pageChangeLoadingEvent.emit(event);
  }


}
